import { useGetPreferencesQuery } from "@/features/manifest/api/preferencesApi";
import { useManifest, useSchedulingEnabled } from "@/features/manifest/model/useManifest";
import { useModulePermissions } from "@/features/manifest/model/useModulePermission";
import { useCurrentUser } from "@/features/auth/model/useAuth";
import { useDeployment } from "@/features/deployment/model/useDeployment";

import type { NavVisibilityCtx } from "./navVisibility";

export function useNavVisibilityCtx(): NavVisibilityCtx {
  const { manifest } = useManifest();
  const { data: orgPrefs } = useGetPreferencesQuery();
  const schedulingEnabled = useSchedulingEnabled();
  const user = useCurrentUser();
  const { isClient } = useDeployment();
  const { canView, hasCapability, fullAccess } = useModulePermissions();

  const isControl = user?.user_type === "control" && !isClient;

  return {
    isControl,
    fullAccess,
    canView,
    hasCapability,
    userRole: user?.role,
    schedulingEnabled,
    modulesEnabled: manifest?.modules_enabled,
    grantManagementEnabled: orgPrefs?.grant_management_enabled,
    inventoryEnabled: orgPrefs?.inventory_enabled,
  };
}
